import './common';
import * as $ from 'jquery';
import validate from 'jquery-validation';

let valid1 = $('#form1').validate({
  rules: {
    keyword: {
      required: function(element) {
        return (($('[name="exhibition"]:checked').val()==undefined && $('[name="lproduct[]"]:checked').length==0 && $("#keyword").val()==''))
      }
    },
  },
  messages: {
    keyword: {
      required: window.lang == 'ja' ? '検索条件を指定して下さい。' : "Please enter 'Key Word'.",
    },
  },
});

document.querySelectorAll('.exhibitor_search-input').forEach(function(item) {
  item.dataset.checked = item.checked;
  item.addEventListener('click', {
    handleEvent: function(event) {
      const id = document.getElementById(event.target.id);
      const checked = id.dataset.checked;
      if (checked === "true"){
        document.querySelectorAll('.exhibitor_search-input').forEach(function(radio) {
          radio.dataset.checked =false;
        });
	id.checked = false;
	id.dataset.checked = false;
      }
      else{
        document.querySelectorAll('.exhibitor_search-input').forEach(function(radio) {
          radio.dataset.checked =false;
        });
	id.checked = true;
	id.dataset.checked = true;
      }
    },
  });
});
